import { connect } from 'react-redux';

const mapStateToProps = ({
  TrackerData:
  { areMapUpdatesPaused, trackerMessage: trackerMessages },
}) => ({ trackerMessages, areMapUpdatesPaused });

export default (WrappedComponent) => connect(mapStateToProps, null)(WrappedComponent);
